import companiesActions from '../actionTypes/companiesActions';

const initialState = {
  isLoading: true,
  data: { companies: [] },
  per: 10,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case companiesActions.getCompaniesList:
      return {
        ...state,
        ...action.payload,
        isLoading: true,
      };
    case companiesActions.getCompaniesListSuccess:
    case companiesActions.getCompaniesListFailed:
      return {
        ...state,
        ...action.payload,
        isLoading: false,
      };
    default:
      return state;
  }
};
